import { Reveal, Chapter } from "./shared";

const items = [
  {
    quote:
      "My Read named a pattern I had never said out loud. Then it told me what to do with it. I did not expect to feel seen by an app.",
    name: "Mara K.",
    role: "Principal, venture capital · 34",
  },
  {
    quote:
      "It said send the email Thursday, and told me why. Thursday got a yes in four hours.",
    name: "Dani R.",
    role: "Founder, two-time exit · 29",
  },
  {
    quote:
      "Co-Star told me about me. SOURCECODED tells me about the room.",
    name: "Ines V.",
    role: "Creative director · 38",
  },
];

export const Testimonials = () => (
  <section className="py-16 sm:py-24 lg:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="09" label="The users" />
      </Reveal>
      <Reveal>
        <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mb-10 sm:mb-16" data-testid="testimonials-headline">
          Ambitious people don't
          <br />
          <span className="text-[#6E7178]">do vague.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12} className="card-line bg-[#141518] p-6 sm:p-8 flex flex-col justify-between" data-testid={`testimonial-card-${i + 1}`}>
            <p className="text-[#F2F0EB] leading-relaxed mb-10">&ldquo;{t.quote}&rdquo;</p>
            <div className="border-t border-[#F2F0EB]/10 pt-5">
              <p className="font-display font-bold">{t.name}</p>
              <p className="text-xs text-[#6E7178] mt-1 uppercase tracking-[0.15em]">{t.role}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
